import { useCallback, useState } from 'react';

// Mesma assinatura de getTasksManager/getTasksManagerNormal/getTasksManagerMad — cada
// fluxo injeta a SUA função de dados e o guard de concorrência revalida contra o mesmo
// aggregate do fluxo (CON-07).
export type TasksFetchFn = (player?: string, start?: any, end?: any, step?: number, taskId?: string) => Promise<any[]>;

export interface TasksQueryParams {
  player?: string;
  start?: any;
  end?: any;
  step?: number;
}

// Port do loadData do ApreciarRealizacao/index.tsx SEM o enriquecimento getTaskStatuses
// (regra de negócio, aplicada por fluxo). Coreografia de loading segue a do original:
// reload só derruba o loading no resultado vazio; a página do fluxo liga/desliga nos
// demais momentos (antes de carregar e após processar filtros), via setLoading exposto.
export function useTasksData(fetchFn: TasksFetchFn) {
  const [data, setData] = useState<any[]>();
  const [loading, setLoading] = useState(true);

  const reload = useCallback(
    async (params?: TasksQueryParams, taskId?: string) => {
      if (!!params) {
        const hasTaskId = typeof taskId === 'string' && taskId.length > 0;

        const myTasks = await fetchFn(params.player, params.start, params.end, params.step, taskId);

        if (Array.isArray(myTasks) && myTasks.length > 0) {
          if (hasTaskId) {
            const taskObj = myTasks.find((t: { _id: string }) => t._id === taskId);

            // Busca pontual: funde a task fresca na lista existente por _id e a devolve —
            // contrato usado pelos guards de concorrência.
            setData(prevdata => {
              return Array.isArray(prevdata) && prevdata.length
                ? prevdata.map(d => {
                    return d._id === taskId ? taskObj : d;
                  })
                : myTasks;
            });

            return taskObj;
          }

          setData(myTasks);

          return myTasks;
        } else {
          if (hasTaskId) {
            return null;
          }

          setData([]);
          setLoading(false);
          return [];
        }
      }

      return typeof taskId === 'string' && taskId.length > 0 ? null : [];
    },
    [fetchFn],
  );

  return { data, setData, loading, setLoading, reload };
}
